import { render, staticRenderFns } from "./AccountPanel.vue?vue&type=template&id=e3630a52&scoped=true&"
import script from "./AccountPanel.vue?vue&type=script&lang=js&"
export * from "./AccountPanel.vue?vue&type=script&lang=js&"
import style0 from "./AccountPanel.vue?vue&type=style&index=0&id=e3630a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3630a52",
  null
  
)

export default component.exports